export const InfoIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
        <path
            fill="#4e5a6b"
            d="M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.35A7.65 7.65 0 1 1 1.35 9 7.64 7.64 0 0 1 9 1.35ZM9 4.5a.9.9 0 1 0 .9.9.9.9 0 0 0-.9-.9Zm-.011 3.14a.675.675 0 0 0-.664.685v4.95a.675.675 0 1 0 1.35 0v-4.95a.675.675 0 0 0-.686-.685Z"
            data-name="icons8-info (13)"
        />
    </svg>
)